export const SimilarityQueryType = {
    'DATA': 'DATA',
    'SEARCH': 'SEARCH',
    'ANALOGICAL': 'ANALOGICAL'
};
